import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CmsService } from '@selfcare/cms';
import { CmsActions } from '@state/cms/cms.actions';

@Injectable()
export class CmsEffects {
  loadPageWidgets = createEffect(() => {
    return this.actions$.pipe(
      ofType(CmsActions.getPageWidgets),
      switchMap(({ url }) =>
        this.cmsService.getWidgetList(url).pipe(
          map((usageChartLike) => CmsActions.getPageWidgetsSuccess(url, usageChartLike)),
          catchError(() => of(CmsActions.getPageWidgetsFailure()))
        )
      )
    );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly cmsService: CmsService
  ) {}
}
